export const CustomerDetailsButton = [
  // { key: "FILE A CLAIM", text: "File a Claim" },
  // { key: "EDIT", text: "Edit" },
  // { key: "EMAIL", text: "Email" },
  // { key: "CALL", text: "Call" },
  // { key: "MARKETING", text: "Marketing" },
  { key: "ADD NOTES", text: "Add Notes" },
];
